<template>
  <div id="user-guide-content" ref="contentId" v-html="$t('owork_base.owork_user_guide.content_pc')"></div>
</template>

<script lang="ts" setup>
  import MarkdownIt from 'markdown-it'
  import { onMounted, nextTick, ref } from 'vue'
  import { userGuide } from '@assets/user_guide_native'

  const contentId = ref<HTMLDivElement>()

  onMounted(() => {
    // mac 端加载的固定地址，暂时无法区分品牌
    // 因为i18n的json对象存储markdown语法的冲突问题，使用renderWord将原始文件转译为html结构后再存储到json文件中，最终使用渲染富文本形式渲染json文件中的i18n语句
    // renderWord(userGuide)
  })

  const renderWord = async (markdownText: string) => {
    const md = new MarkdownIt()

    const htmlText = md.render(markdownText)

    const content = contentId.value

    console.log(JSON.stringify({ htmlText }))

    if (!content) return

    await nextTick()
    content.innerHTML = htmlText
  }
</script>
<style lang="stylus" scoped>
  #user-guide-content
    :deep(ol)
    :deep(ul)
    :deep(dl)
      margin-left 20px
      margin-bottom 0
    :deep(p)
      margin-bottom 10px
</style>
